import { CalendarEventStatusEnum  } from "../../enums/calendar-status-enum"
import { EntityTypeEnum } from "../../enums/entity-type-id-enum"

export class AttendeeModel { 
    id: string | undefined; 
    email: string | undefined; 
    type: EntityTypeEnum | undefined; 
    status: CalendarEventStatusEnum   | undefined; 
    name: string | undefined; 


    constructor(id: string, type: EntityTypeEnum, status: CalendarEventStatusEnum , name:string, email: string|undefined ){
            this.id = id; 
            this.type = type; 
            this.status = status;
            this.name = name;
            this.email = email;
    }
}

